__turbopack_context__.v({
  "backIcon": "Ir3W5a_backIcon",
  "backLink": "Ir3W5a_backLink",
  "container": "Ir3W5a_container",
  "isLast": "Ir3W5a_isLast",
  "item": "Ir3W5a_item",
  "separator": "Ir3W5a_separator",
  "wide": "Ir3W5a_wide",
});
